import {useState, useEffect} from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl"

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useTokenContext } from "App";

// Billing page components
import AvatarsList from "layouts/retailerAvatars/components/AvatarsList";
import {getAvatars} from "api/avatars/getAvatars"
import ModalAvatarsData from "layouts/retailerAvatars/ModalAvatarsData"
import ModalDialog from "components/ModalDialog/ModalDialog";

import {searchBoxStyle} from "./styles/searchbox_style"

function RetailerAvatars() {
  const [searchText, setSearchText] = useState('');
  const [avatars, setAvatars] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const {token} = useTokenContext();


  const handleTextChange = (event) => {
    setSearchText(event.target.value);
  };

  function onCloseModalClick(){
    setShowModal(false)
  }

  function onViewClick(){
    console.log('a')
    setShowModal(true)
  }
  
  const doGetAvatars = async () => {
    try{
      let avatarsPromise = await getAvatars(token);
      setAvatars(avatarsPromise);

    } catch (error) {
      console.error("Error on get avatars: ", error)
    }
  }

  useEffect(() => {
    doGetAvatars();
  }, []);

  const modalData = <ModalAvatarsData />

  return (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <FormControl sx={{ m: 1, width: '40ch' }}>
          <TextField fullWidth label="Search avatar by nickname, preferences or survey answers..." onChange={handleTextChange} InputLabelProps={searchBoxStyle.placeholder} sx={[searchBoxStyle.text, searchBoxStyle.border]} variant="outlined" />
        </FormControl>
      </MDBox>
      <MDBox mt={1}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              {avatars && 
              <AvatarsList avatars={avatars["data"]} onViewClick={onViewClick}/>
              }
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
    {showModal &&
        <ModalDialog 
          onCloseModalClick={onCloseModalClick} 
          title={'Avatar detail'}
          content={modalData}
        />
    }
    </>
  );
}

export default RetailerAvatars;
